import type { ReactNode } from "react";

import { Button } from "@aviary";

import * as styles from "./SearchFilterButton.styles";

interface Props {
  isActive: boolean;
  toggleOpenSearchFilter: () => void;
  children: ReactNode;
  isSmall?: boolean;
}

const SearchFilterButton = ({
  children,
  toggleOpenSearchFilter,
  isActive,
  isSmall,
  ...rest
}: Props) => {
  const buttonColor = isActive ? "primary" : "system";

  return (
    <Button
      css={styles.searchFilterButton}
      isColor={buttonColor}
      onClick={toggleOpenSearchFilter}
      size={isSmall ? "medium" : "large"}
      {...rest}
    >
      {children}
    </Button>
  );
};

export { SearchFilterButton };
